import { render, staticRenderFns } from "./AnnualityForm.vue?vue&type=template&id=4879d054&scoped=true&"
import script from "./AnnualityForm.vue?vue&type=script&lang=js&"
export * from "./AnnualityForm.vue?vue&type=script&lang=js&"
import style0 from "./AnnualityForm.vue?vue&type=style&index=0&id=4879d054&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4879d054",
  null
  
)

export default component.exports